<template>
    <vs-button type="border" icon-pack="feather" icon="icon-corner-left-down" @click="$emit('selectGoal')">Assign Goals ({{this.selectGoalEnabled}})</vs-button>
</template>

<script>
export default {
  props: {
    selectGoalEnabled: {
      type: Number
    }
  }
}
</script>
